<i18n lang='yml' src='../i18n/ManageFeatures.yml'></i18n>

<template>
  <div v-if="loading">
    <loading-animation-vue></loading-animation-vue>
  </div>
  <div v-else class="white-bg padded margin-bottom">
    <fieldset>
      <legend>{{ $t('header') }}</legend>
      <div class='form-group row'>
        <div class='col-sm-12 col-md-6 col-lg-4' v-for='nalb in networkNalbs'>
          <label v-if='nalb.name == "Messages"'>
            <input type='checkbox' disabled :title="$t('unavailable')" :name='networkNalbFieldName' :value='nalb.id' v-model='nalb.selected'>
            {{ nalb.name }}
          </label>
          <label v-else>
            <input type='checkbox' :name='networkNalbFieldName' :value='nalb.id' v-model='nalb.selected'>
            {{ nalb.name }}
          </label>
        </div>
        <input type='hidden' :name='networkNalbFieldName' value=''>
      </div>
      <div class='form-group row'>
        <div class='col-sm-12'>
          <label for='default_nalb'>{{ $t('default_feature') }}</label>
          <select id='default_nalb' class='form-control' :name='defaultNalbFieldName'>
            <option v-for='nalb in availableNalbs' :value='nalb.id' :selected='nalb.default'>{{ nalb.name }}</option>
          </select>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { sendAjaxRequest } from '../../../../shared/typescripts/ajax.ts'
export default {
  props: ['locale', 'endpoint', 'networkNalbFieldName', 'defaultNalbFieldName'],
  data () {
      return { networkNalbs: [], loading: true }
  },
  mounted () {
      this.$i18n.locale = this.locale;
      sendAjaxRequest('GET', this.endpoint + '.json', 'json', {}, this.ajaxSuccess)
  },
  computed: {
    availableNalbs: function () {
      return this.networkNalbs.filter((item) => item.selected);
    }
  },

  methods: {
    ajaxSuccess(data) {
      const self = this;
      self.networkNalbs = data['networkNalbs'];
      for (let pos = 0; pos < self.networkNalbs.length; pos++) {
        self.networkNalbs[pos].selected = false;
        self.networkNalbs[pos].default = false;
      }
      for (let pos = 0; pos < data['availableNalbs'].length; pos++) {
        const availableNalb = data['availableNalbs'][pos];
        const networkNalbIdx = self.networkNalbs.findIndex((item) => item.id === availableNalb[0]);
        self.networkNalbs[networkNalbIdx].selected = true;
        if (availableNalb[1]) {
          self.networkNalbs[networkNalbIdx].default = true;
        }
      }
      self.loading = false;
    }
  }
}
</script>
